import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  profile: number;
  name: string;
  ceased_on: string;
  reason: string;
}

export const useCreatePortalFormerName = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/portal_former_name/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
